import Footer from "../components/Footer";
import Header from "../components/Header";
import AquaIndiaSolidBrandPage from "./AquaIndiaSolidBrandPageV2";

const Aqua2026 = () => {
  return (
    <>
      <Header />
      <AquaIndiaSolidBrandPage />
      <Footer />
    </>
  );
};

export default Aqua2026;
